var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ic_cost",
    transform: "translate(0)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 40,
    height: 40,
    rx: 4,
    transform: "translate(0)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M24.311-24.51a1.171,1.171,0,0,0-1.906,0C20.213-21.338,15-13.432,15-9.964a8.162,8.162,0,0,0,8.358,7.949,8.162,8.162,0,0,0,8.358-7.949C31.716-13.432,26.5-21.338,24.311-24.51Z",
    transform: "translate(-4.948 32.463)",
    fill: "#4e09f8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M17-11.6a.634.634,0,0,0-.63-.63h-.585V-17.27a.634.634,0,0,0-.63-.63h-1.8a.576.576,0,0,0-.518.344l-.63,1.17a.634.634,0,0,0,.029.62.633.633,0,0,0,.531.3h.587v3.239h-.585a.634.634,0,0,0-.63.63v1.169a.634.634,0,0,0,.63.63h3.6a.634.634,0,0,0,.63-.63ZM29.149-21.629a2.646,2.646,0,0,0-1.5-2.433,12.7,12.7,0,0,0-5.36-1.125,30.774,30.774,0,0,0-8.035,1.453,28.556,28.556,0,0,1-7.392,1.366A10.57,10.57,0,0,1,3.4-22.921a2.519,2.519,0,0,0-.836-.142A2.609,2.609,0,0,0,0-20.415V-6.074A2.646,2.646,0,0,0,1.5-3.641a12.7,12.7,0,0,0,5.36,1.125A30.774,30.774,0,0,0,14.9-3.968a28.556,28.556,0,0,1,7.392-1.366,10.57,10.57,0,0,1,3.464.552,2.519,2.519,0,0,0,.836.142,2.612,2.612,0,0,0,2.561-2.654Z",
    transform: "translate(3 30.09)",
    fill: "rgba(3,209,207,0.99)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M17-11.6a.634.634,0,0,0-.63-.63h-.585V-17.27a.634.634,0,0,0-.63-.63h-1.8a.576.576,0,0,0-.518.344l-.63,1.17a.634.634,0,0,0,.029.62.633.633,0,0,0,.531.3h.587v3.239h-.585a.634.634,0,0,0-.63.63v1.169a.634.634,0,0,0,.63.63h3.6a.634.634,0,0,0,.63-.63ZM29.149-21.629a2.646,2.646,0,0,0-1.5-2.433,12.7,12.7,0,0,0-5.36-1.125,30.774,30.774,0,0,0-8.035,1.453,28.556,28.556,0,0,1-7.392,1.366A10.57,10.57,0,0,1,3.4-22.921a2.519,2.519,0,0,0-.836-.142A2.609,2.609,0,0,0,0-20.415V-6.074A2.646,2.646,0,0,0,1.5-3.641a12.7,12.7,0,0,0,5.36,1.125A30.774,30.774,0,0,0,14.9-3.968a28.556,28.556,0,0,1,7.392-1.366,10.57,10.57,0,0,1,3.464.552,2.519,2.519,0,0,0,.836.142,2.612,2.612,0,0,0,2.561-2.654Z",
    transform: "translate(8.851 37.613)",
    fill: "#303fd0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2",
    "data-name": "Intersection 2",
    d: "M0,15.115V4.773A2.61,2.61,0,0,1,2.561,2.124a2.513,2.513,0,0,1,.836.143,10.561,10.561,0,0,0,3.463.552,28.558,28.558,0,0,0,7.392-1.366A30.79,30.79,0,0,1,22.288,0Q22.8,0,23.3.035V10.371a2.612,2.612,0,0,1-2.562,2.655,2.525,2.525,0,0,1-.835-.142,10.574,10.574,0,0,0-3.465-.552A28.526,28.526,0,0,0,9.045,13.7a30.777,30.777,0,0,1-8.035,1.452Q.5,15.149,0,15.115Z",
    transform: "translate(8.85 12.425)",
    fill: "rgba(3,209,207,0.99)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.b4a729d315d7ecfe0fb56bc37f974f52.svg";
export { ForwardRef as ReactComponent };